// Revival: Klaviyo back in stock placement.
// The [data-rv-bis] box (rendered by the offer block) holds .klaviyo-bis-trigger, where Klaviyo's onsite script draws its button.
// Moves the box under the add to cart button, shows it only while the selected variant is sold out,
// and marks the product details with .rv-soldout so the subscription options are hidden for sold-out variants.
(function () {
  if (window.RevivalBis) return;
  window.RevivalBis = true;
  function init() {
    var box = document.querySelector('[data-rv-bis]');
    if (!box) return;
    var map = {};
    try { map = JSON.parse(box.parentNode.querySelector('[data-rv-avail]').textContent); } catch (e) {}
    var details = box.closest('.product-details') || document.body;
    var buttons = details.querySelector('.buy-buttons-block');
    if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(box, buttons.nextSibling);
    function update(id) {
      id = id || (window.RevivalVariantSync ? window.RevivalVariantSync.currentId() : '');
      if (!id || !(id in map)) return;
      var soldOut = map[id] === false;
      box.hidden = !soldOut;
      details.classList.toggle('rv-soldout', soldOut);
    }
    document.addEventListener('revival:variant', function (e) { update(e.detail && e.detail.id); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
